import { maxBy } from 'lodash-es';

import type { MappedRoundTripNearestSearch } from '../types';

const getTotalPrice = (
  activeSearchTo: MappedRoundTripNearestSearch,
  activeSearchBack: MappedRoundTripNearestSearch,
) => {
  return Number(activeSearchBack.price) + Number(activeSearchTo.price);
};

const getMaxPrice = (searches: MappedRoundTripNearestSearch[]) => {
  return maxBy(searches, 'price')?.price;
};

export const pricesLib = {
  getTotalPrice,
  getMaxPrice,
};
